import React from 'react';
import * as Styled from "./styled";

const ScreeningInterview = ( {interview} ) => {
  return (
    <Styled.InterviewCard>
      <Styled.InterviewInfo>
        <p>{interview.title}</p>
        <p>Skill: {interview.skill}</p>
        <p>Duration:  {interview.duration}</p>
      </Styled.InterviewInfo>
      <div className="interview-video">
        <video style={{ width: "100%", height: "auto", maxWidth: "100%" }} controls>
          <source src={interview.videoSrc} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </Styled.InterviewCard>
  );
};

export default ScreeningInterview;
